enum Actions {
  FETCH_COUNTRIES = 'fetchCountries',
}
enum Mutations {
  SET_COUNTRY_LIST = 'setCountryList',
}
export { Actions, Mutations }
